module.exports = __webpack_public_path__ + "static/step4-1e7ea154bfe7d03382ba4f97508ef3d7.png";